module.exports = __webpack_public_path__ + "0b7e8e430f0b782477c550b574cfdeaa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-32.png
// module id = 2093
// module chunks = 0